(function ($) {
    $.widget('femcare.multiChoice', {
        options: {},

        _create: function () {
            this.$choices = this.element.find('[type="checkbox"]');
            this.$hiddenInput = this.element.find('[type="hidden"]');

            this.$choices.on('click', function () {
                this._setHiddenInputValue();
            }.bind(this));
        },

        _setHiddenInputValue: function () {
            var values = [];
            this.$choices.each(function () {
                if($(this).is(':checked')){
                    values.push($(this).val());
                }
            });

            this.$hiddenInput.val(values.join(','));
            this.$hiddenInput.validate();
        }
    });

})(jQuery);